import { getCookie } from 'lib/cookies';
// import axios from 'axios';
import axiosInstance from 'configs/axiosConfig';

const config = () => {
  return {
    headers: {
      'Authorization': `Bearer ${getCookie('access')}`,
      'Set-Cookie': getCookie('refresh'),
    },
  };
};

// 팝업 관리 --------------------------------------------------------------------------------------\\
export function getPopupList() {
  return axiosInstance.get(`${process.env.REACT_APP_URI}${process.env.REACT_APP_POPUP_API}`, config());
}

export function createPopup(dataToSubmit) {
  return axiosInstance.post(`${process.env.REACT_APP_URI}${process.env.REACT_APP_POPUP_API}`, dataToSubmit, config());
}

export function uploadPopupImage(dataToSubmit) {
  return axiosInstance.post(`${process.env.REACT_APP_URI}${process.env.REACT_APP_POPUP_API}/upload/image`, dataToSubmit, config());
}

export function getOnePopup(idx) {
  return axiosInstance.get(`${process.env.REACT_APP_URI}${process.env.REACT_APP_POPUP_API}/${idx}`, config());
}

export function editPopup(dataToSubmit) {
  return axiosInstance.patch(`${process.env.REACT_APP_URI}${process.env.REACT_APP_POPUP_API}`, dataToSubmit, config());
}

export function deletePopup(dataToSubmit) {
  let axiosConfig = config();
  axiosConfig = { ...axiosConfig, data: dataToSubmit };

  return axiosInstance.delete(`${process.env.REACT_APP_URI}${process.env.REACT_APP_POPUP_API}`, axiosConfig);
}
// 팝업 관리 --------------------------------------------------------------------------------------//

// 배너 관리 --------------------------------------------------------------------------------------\\
export function uploadBannerImage(dataToSubmit) {
  return axiosInstance.post(`${process.env.REACT_APP_URI}${process.env.REACT_APP_BANNER_API}/upload/image`, dataToSubmit, config());
}

export function createBanner(dataToSubmit) {
  return axiosInstance.post(`${process.env.REACT_APP_URI}${process.env.REACT_APP_BANNER_API}`, dataToSubmit, config());
}

export function getBannerList() {
  return axiosInstance.get(`${process.env.REACT_APP_URI}${process.env.REACT_APP_BANNER_API}`, config());
}

export function getBanner(idx) {
  return axiosInstance.get(`${process.env.REACT_APP_URI}${process.env.REACT_APP_BANNER_API}/${idx}`, config());
}

export function editBanner(dataToSubmit) {
  return axiosInstance.patch(`${process.env.REACT_APP_URI}${process.env.REACT_APP_BANNER_API}`, dataToSubmit, config());
}

export function deleteBanner(dataToSubmit) {
  let axiosConfig = config();
  axiosConfig = { ...axiosConfig, data: dataToSubmit };

  return axiosInstance.delete(`${process.env.REACT_APP_URI}${process.env.REACT_APP_BANNER_API}`, axiosConfig);
}
// 배너 관리 --------------------------------------------------------------------------------------//
